import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function FloatingMessageButton() {
  return <motion.a href="sms:4233203426" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1.5,
    type: 'spring',
    stiffness: 200,
    damping: 15
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.95
  }} className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-brand-gold text-black rounded-full flex items-center justify-center shadow-2xl shadow-brand-gold/30 hover:bg-brand-goldLight transition-colors" aria-label="Send us a message" data-id="element-39">
      <MessageCircle size={28} strokeWidth={2.5} data-id="element-40" />

      {/* Pulse ring animation */}
      <span className="absolute inset-0 rounded-full bg-brand-gold animate-ping opacity-20 pointer-events-none" data-id="element-41"></span>
    </motion.a>;
}